import React from "react";
import moment from "moment";
import EyeConnectEnrolmentForm from "./EyeConnectEnrolmentForm";
import EyeConnectEnrolmentConfirm from "./EyeConnectEnrolmentConfirm";
import EyeConnectEnrolmentSuccess from "./EyeConnectEnrolmentSuccess";
import { EnrolmentValues, ResearchParticipantValues } from "./types";

export type State = {
  showEnrolmentSuccess: boolean;
  currentPage: number;
  values: EnrolmentValues;
  previousEnrolment: {
    patientName: string;
    patientDob: string;
    recallPeriod: string;
  };
};

type Props = {
  csrfToken: string;
  gtag: string;
  gaTrackingId: string;
  gaTracking: string;
  initialState?: State;
};

export const defaultState: State = {
  showEnrolmentSuccess: false,
  currentPage: 0,
  values: {
    title: "",
    first_name: "",
    surname: "",
    dob: "",
    postcode: "",
    ndss: "",
    indigenous: "",
    patient_consent: false,
    practice_name: "",
    visual_acuity_right: "",
    visual_acuity_right_normal_with_modifier: "",
    visual_acuity_left: "",
    visual_acuity_left_normal_with_modifier: "",
    diabetic_retinopathy_left: "",
    diabetic_retinopathy_right: "",
    macular_oedema_left: "none",
    macular_oedema_right: "none",
    hba1c: "",
    hba1c_unknown: false,
    last_eye_test: "unknown_never",
    left_eye_image: "",
    right_eye_image: "",
    left_oct_eye_image: "",
    right_oct_eye_image: "",
    follow_up_sms: false,
    follow_up_sms_number: "",
    follow_up_email: false,
    follow_up_email_address: "",
    follow_up_post: false,
    follow_up_post_address: "",
    recall_months: "2_years",
    research_participant: true,
  },
  previousEnrolment: {
    patientName: "",
    patientDob: "",
    recallPeriod: "",
  },
};

export default function EyeConnectEnrolment(props: Props) {
  const initialState = {
    ...defaultState,
    ...(props.initialState || {}),
  };

  const [state, setState] = React.useState<State>(initialState);

  const dismissEnrolmentSuccess = () => {
    setState((prevState) => {
      return { ...prevState, showEnrolmentSuccess: false };
    });
  };

  const nextPage = () => {
    setState((prevState) => {
      return { ...prevState, currentPage: state.currentPage + 1 };
    });
    window.scrollTo(0, 0);
  };

  const previousPage = () => {
    setState((prevState) => {
      return { ...prevState, currentPage: state.currentPage - 1 };
    });
    window.scrollTo(0, 0);
  };

  const saveEnrolmentForm = (values: any) => {
    setState((prevState) => {
      return {
        ...prevState,
        values: {
          ...values,
          date_of_fundus_exam: moment(Date.now()).format("DD/M/YYYY"),
        },
      };
    });
    nextPage();
  };

  const renderEnrolmentSuccess = () =>
    state.showEnrolmentSuccess && (
      <EyeConnectEnrolmentSuccess
        gaTrackingId={props.gaTrackingId}
        gaTracking={props.gaTracking}
        gtag={props.gtag}
        isDismissClick={dismissEnrolmentSuccess}
        patientName={state.previousEnrolment.patientName}
        patientDob={state.previousEnrolment.patientDob}
        recallPeriod={state.previousEnrolment.recallPeriod}
      />
    );

  const renderForm = () => (
    <div>
      {renderEnrolmentSuccess()}
      <EyeConnectEnrolmentForm
        {...props}
        values={state.values}
        saveEnrolmentForm={saveEnrolmentForm}
      />
    </div>
  );

  const renderNewForm = ({
    previousEnrolment = { patientName: "", patientDob: "", recallPeriod: "" },
  } = {}) => {
    setState(initialState);
    if (Object.keys(previousEnrolment).length > 0) {
      setState((prevState) => {
        return {
          ...prevState,
          showEnrolmentSuccess: true,
          previousEnrolment,
        };
      });
    }
  };

  const renderReview = () => (
    <EyeConnectEnrolmentConfirm
      {...props}
      values={state.values}
      previousPage={previousPage}
      renderNewEnrolmentForm={renderNewForm}
    />
  );

  return (
    <div className="lander">
      {state.currentPage === 0 ? renderForm() : renderReview()}
    </div>
  );
}
